<template>
  <div style="padding: 0px 10px">
    <a-spin :spinning="!brData.id || loading">
      应用追溯
      <!-- <BrRetrospectUse /> -->
      <a-collapse v-model="collapseExpand1" :bordered="false" style="background: #fff">
        <template #expandIcon="props">
          <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
        </template>
        <a-collapse-panel v-for="(item, idx) in dataList.filter(i => i.type === 1)" :key="idx + ''" :style="customStyle">
          <template slot="header">
            <a-row :gutter="18">
              <a-col :span="15">
                <span style="font-weight: 500">{{ item.title }}</span>
                <span v-if="!isExpand(collapseExpand1, idx)" style="margin-left: 10px; color: #a89d9d">
                  <span>{{ item.startTime || '--' }}</span>
                </span>
                <span style="float: right">
                  <a-button v-if="isProductOperation || isBusiness" v-tc="{ name: '编辑应用追溯' }" type="link" size="small" @click.stop="openBrRetrospectModal('use', true, item)">编辑</a-button>
                </span>
              </a-col>
              <a-col :span="9" class="right-col">
                <div style="display: flex">
                  <i style="font-weight: 500; flex-shrink: 0; margin-right: 8px"> 小结 </i>
                  <div v-if="!isExpand(collapseExpand1, idx)" style="color: #a89d9d; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    <span v-if="checkHtml(item.conclusionDoc) === false">
                      {{ item.conclusionDoc }}
                    </span>
                    <span v-else> 暂无小结 </span>
                  </div>
                  <div style="margin-left: auto">
                    <a-button v-if="isProductPo || isTechnicalManager" v-tc="{ name: '编辑应用追溯小结' }" type="link" size="small" @click.stop="openBrRetrospectModal('use_conclusion', true, item)">编辑</a-button>
                  </div>
                </div>
              </a-col>
            </a-row>
          </template>
          <div style="padding-left: 23px">
            <a-row :gutter="18">
              <a-col :span="15">
                <div v-if="item" style="margin-bottom: 10px">
                  <div class="left-title" style="margin-bottom: 5px">应用时间：{{ item.startTime || '--' }}</div>
                  <div class="left-title" style="margin-bottom: 5px">
                    <span style="margin-left: 28px"> 附件: </span>
                    <span v-if="(!item.files || item.files.length == 0) && (!item.images || item.images.length == 0)" style="font-weight: 400; color: #a89d9d"> 暂无附件 </span>
                  </div>
                  <UploadImg :is-edit="false" :data-list="item.images" />
                  <UploadFile style="margin-top: 10px" :is-edit="false" :data-list="item.files" />
                </div>
              </a-col>
              <a-col :span="9" class="right-col">
                <div class="left-title">追溯小结：</div>
                <VditorPreview v-if="checkHtml(item.conclusionDoc) === false" style="font-size: 14px" :content="item.conclusionDoc" />
              </a-col>
            </a-row>
          </div>
        </a-collapse-panel>
      </a-collapse>
      <template v-if="brData && brData.retrospectType && brData.retrospectType.includes(2)">
        价值追溯
        <a-collapse v-model="collapseExpand2" :bordered="false" style="background: #fff">
          <template #expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <a-collapse-panel v-for="(item, idx) in dataList.filter(i => i.type === 2)" :key="idx + ''" :style="customStyle">
            <template slot="header">
              <a-row :gutter="18">
                <a-col :span="15">
                  <span style="font-weight: 500">{{ item.title }}</span>
                  <span v-if="!isExpand(collapseExpand2, idx)" style="margin-left: 10px; color: #a89d9d">
                    <span>{{ item.startTime || '--' }} ~ {{ item.endTime || '--' }}</span>
                  </span>
                  <span style="float: right">
                    <a-button v-if="isProductOperation || isBusiness" v-tc="{ name: '编辑价值追溯' }" type="link" size="small" @click.stop="openBrRetrospectModal('value', true, item)">编辑</a-button>
                  </span>
                </a-col>
                <a-col :span="9" class="right-col">
                  <div style="display: flex">
                    <i style="font-weight: 500; flex-shrink: 0; margin-right: 8px"> 小结 </i>
                    <div v-if="!isExpand(collapseExpand1, idx)" style="color: #a89d9d; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                      <span v-if="checkHtml(item.conclusionDoc) === false">
                        {{ item.conclusionDoc }}
                      </span>
                      <span v-else> 暂无小结 </span>
                    </div>
                    <div style="margin-left: auto">
                      <a-button v-if="isProductPo || isTechnicalManager" v-tc="{ name: '编辑价值追溯小结' }" type="link" size="small" @click.stop="openBrRetrospectModal('value_conclusion', true, item)">编辑</a-button>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </template>
            <div style="padding-left: 23px">
              <a-row :gutter="18">
                <a-col :span="15">
                  <div v-if="item" style="margin-bottom: 10px">
                    <div style="margin-bottom: 10px">
                      <div class="left-title" style="margin-bottom: 5px">时间阶段：{{ item.startTime || '--' }} ~ {{ item.endTime || '--' }}</div>
                      <div class="left-title" style="margin-bottom: 5px">追溯信息：</div>
                      <div style="padding-left: 20px">
                        <VditorPreview v-if="checkHtml(item.retrospectDoc) === false" style="font-size: 14px" :content="item.retrospectDoc" />
                      </div>
                    </div>
                    <div class="left-title" style="margin-bottom: 5px">
                      <span style="margin-left: 28px"> 附件: </span>
                      <span v-if="(!item.files || item.files.length == 0) && (!item.images || item.images.length == 0)" style="font-weight: 400; color: #a89d9d"> 暂无附件 </span>
                    </div>
                    <UploadImg :is-edit="false" :data-list="item.images" />
                    <UploadFile style="margin-top: 10px" :is-edit="false" :data-list="item.files" />
                  </div>
                </a-col>
                <a-col :span="9" class="right-col">
                  <div class="left-title" style="margin-bottom: 10px">
                    是否符合预期：
                    <span v-if="item.valueIsReach == null" style="font-weight: 400">--</span>
                    <a-tag v-else :color="item.valueIsReach ? '#87d068' : '#f50'">{{ item.valueIsReach ? '是' : '否' }}</a-tag>
                  </div>
                  <div style="margin-bottom: 10px">
                    <div class="left-title">追溯小结：</div>
                    <div style="padding-left: 20px">
                      <VditorPreview v-if="checkHtml(item.conclusionDoc) === false" style="font-size: 14px" :content="item.conclusionDoc" />
                    </div>
                  </div>
                  <div style="margin-bottom: 10px">
                    <div class="left-title">后续计划：</div>
                    <div style="padding-left: 20px">
                      <VditorPreview v-if="checkHtml(item.afterPlanDoc) === false" style="font-size: 14px" :content="item.afterPlanDoc" />
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-collapse-panel>
        </a-collapse>
        <a-button v-if="isProductOperation" v-tc="{ name: '新增价值追溯' }" style="margin-top: 8px" icon="plus" type="primary" @click.stop="openBrRetrospectModal('value', false)"> 新增价值追溯 </a-button>
      </template>
      <BrRetrospectModal ref="brRetrospectModalRef" :br-id="brId" @saveOK="getDataList()" />
    </a-spin>
  </div>
</template>

<script>
import BrRetrospectModal from '@/pages/business/requirement/components/BrRetrospectModal';
import { queryBrRetrospect, createBrRetrospect } from '@/api/business/requirement';
import UploadImg from '@/pages/business/requirement/components/UploadImg';
import UploadFile from '@/pages/business/requirement/components/UploadFile';
import VditorPreview from '@/components/VditorEditor/preview';
import { checkHtml } from '@/utils/utils';

export default {
  components: { BrRetrospectModal, UploadImg, UploadFile, VditorPreview },
  props: {
    brData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      loading: true,
      projectId: 0,
      brId: parseInt(this.$route.params.id) || null,
      dataList: [],
      collapseExpand1: ['0'],
      collapseExpand2: [],
      customStyle: 'border-radius: 4px;margin-bottom: 8px;overflow: hidden'
    };
  },
  computed: {
    isProductOperation() {
      const userId = this.$store.state.userInfo.id;
      if (this.brData.productOperation && this.brData.productOperation.includes(userId)) {
        return true;
      }
      return false;
    },
    // 产品PO
    isProductPo() {
      const userId = this.$store.state.userInfo.id;
      if (this.brData.po && this.brData.po.includes(userId)) {
        return true;
      }
      return false;
    },
    // 技术经理
    isTechnicalManager() {
      const userId = this.$store.state.userInfo.id;
      if (this.brData.technicalManager && this.brData.technicalManager.includes(userId)) {
        return true;
      }
      return false;
    },
    isBusiness() {
      // 是否业务方
      const userId = this.$store.state.userInfo.id;
      if (this.brData.businessPartner && this.brData.businessPartner === userId) {
        return true;
      }

      if (this.brData.businessCorrelation && this.brData.businessCorrelation.includes(userId)) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.getDataList();
  },
  destroyed() {},
  methods: {
    isExpand(collapseExpands, key) {
      return collapseExpands.includes(key + '');
    },
    checkHtml,
    init() {},
    openBrRetrospectModal(type, isEdit, record) {
      this.$refs.brRetrospectModalRef.onOpen(type, isEdit, record);
    },
    onReload() {
      this.$emit('onReload');
    },
    initData() {},
    /**
     * 获取需求详情
     */
    getDataList() {
      const filter = { brId: this.brId };
      this.loading = true;
      queryBrRetrospect(filter)
        .then(res => {
          this.dataList = res.data.items || [];
          // this.pagination.total = res.data.total;
          if (this.collapseExpand2 && this.collapseExpand2.length === 0) {
            this.collapseExpand2 = this.dataList.filter(i => i.type === 2).map((item, idx) => idx + '');
          }
          this.loading = false;
          // 如果数据为空，进行初始化数据
          if (this.dataList.length === 0) {
            this.initBrRetrospect();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async initBrRetrospect() {
      this.loading = true;
      const formData = {
        id: 0,
        title: '应用追溯',
        brId: this.brId,
        type: 1,
        images: [],
        files: [],
        startTime: '',
        endTime: '',
        valueIsReach: null,
        retrospectDoc: '',
        conclusionDoc: '',
        afterPlanDoc: ''
      };
      try {
        await createBrRetrospect(formData);
        formData.title = '追溯阶段';
        formData.type = 2;
        await createBrRetrospect(formData);
        this.getDataList();
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.left-title {
  font-weight: 500;
  color: #535050;
}

.right-col {
  border-left: 1px solid #e5dede;
  padding-left: 12px !important;
}

/deep/.ant-collapse-item {
  border: 1px solid #e5dede;
  transition: transform 0.3s ease;
}

/deep/.ant-collapse-item:hover {
  box-shadow: 3px 3px 5px 2px rgba(0, 0, 0, 0.06);
  transform: scale(1.003);
}

/deep/.ant-collapse > .ant-collapse-item {
  border-bottom: 1px solid #e5dede;
}

/deep/.vditor-reset {
  max-width: 900px !important;
  width: 100% !important;
}
</style>
